import React from 'react';
import moneyBackSrc from 'assets/money-back-guarantee.png';
import css from './BlueLayout.module.css';
import { G2BadgeTop50, MetaBadge } from '@mm/icons';

export const SignUpLikeLayout = () => (
  <div className={css.headlineContainer}>
    <div className={css.headline}>
      <span>See how many leads you can get from your website</span>

      <span className={css.subtitle}>You can generate 100,000+ leads!</span>
    </div>

    <div className={css.badges}>
      <G2BadgeTop50 />
      <MetaBadge className={css.badge} />
      <img src={moneyBackSrc} />
    </div>
  </div>
);
